let ReviewType = {
  ECOMMERCE: 1,
  SALON_STYLIST: 2,
  TO_REVIEW: 1,
  HISTORY: 2
}

let ToReview = {
  type: {
    SALON: 2,
    STYLIST: 3
  },
  reviewType: {
    NONE: 0,
    CLEANLINESS: 1,
    AMBIENCE: 2,
    CUSTOMER_SERVICE: 3,
    RECOMMENDABLE: 4,
    FRIENDLINESS: 5,
    SKILLFULLNESS: 6,
    RESPONSIVENESS: 7,
    PERSONAL_IMAGE: 8
  }
}

export { ReviewType, ToReview }
